import { NavLink } from "react-router-dom";
import type { ReactNode } from "react";

function CatalogIcon() {
  return (
    <svg className="hw-bottom-nav__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.4" fill="none" stroke="currentColor" strokeWidth="1.7" />
    </svg>
  );
}

function CollectionIcon() {
  return (
    <svg className="hw-bottom-nav__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
        d="M4.5 15.5h15l-1.4-4.2a2 2 0 0 0-1.9-1.3H7.8a2 2 0 0 0-1.9 1.3L4.5 15.5z"
      />
      <circle cx="8" cy="16.8" r="1.55" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="16" cy="16.8" r="1.55" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        d="M7.2 10h5.1l1.4-2.4H9.1z"
      />
    </svg>
  );
}

function ProfileIcon() {
  return (
    <svg className="hw-bottom-nav__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="8.2" r="3.1" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        d="M5.8 18.6c1.4-2.6 3.5-3.9 6.2-3.9s4.8 1.3 6.2 3.9"
      />
    </svg>
  );
}

function BottomNavItem({
  to,
  label,
  icon,
}: {
  to: string;
  label: string;
  icon: ReactNode;
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `hw-bottom-nav__item${isActive ? " hw-bottom-nav__item--active" : ""}`
      }
      end
    >
      {icon}
      <span className="hw-bottom-nav__label">{label}</span>
    </NavLink>
  );
}

export function BottomNav() {
  return (
    <nav className="hw-bottom-nav" aria-label="Основная навигация">
      <BottomNavItem to="/catalog" label="Каталог" icon={<CatalogIcon />} />
      <BottomNavItem to="/collection" label="Коллекция" icon={<CollectionIcon />} />
      <BottomNavItem to="/profile" label="Профиль" icon={<ProfileIcon />} />
    </nav>
  );
}
